const storeBase = require('../lib/storeBase');

module.exports = function storeFactory(dispatcher) {
  const store = Object.create(storeBase.prototype),
    initials = {};
  let refreshUI = false,
    size = {},
    email = '',
    monogramUGC = 'none',
    view = 'front',
    initialsMinLength = null;

  // Begin public API
  store.currentView = function() {
    return view;
  };

  store.currentSize = function() {
    return size;
  };

  store.refreshUI = function() {
    return refreshUI;
  };

  store.trigger = function(callback) {
    setTimeout(callback, 0);
  };

  store.initials = function() {
    return initials;
  };
  store.initialsMinLength = function() {
    return initialsMinLength;
  };

  store.getEmail = function() {
    return email;
  };
  store.monogramUGC = function() {
    return monogramUGC;
  };

  store.dispatcherToken = dispatcher.register(function(action) {
    switch (action.type) {
      case 'updateView':
        view = action.view;
        refreshUI = true;
        store.emitChange();
        break;

      case 'updateSize':
        size = action.size;
        refreshUI = true;
        store.emitChange();
        break;

      case 'saveEmail':
        email = action.email;
        refreshUI = true;
        store.emitChange();
        break;

      case 'updateMonogramUGC':
        monogramUGC = action.monogramUGC;
        refreshUI = true;
        store.emitChange();
        break;

      case 'imageLoaded':
        refreshUI = true;
        store.emitChange();
        break;

      case 'storeInitials':
        initials[action.absoluteParent] = action.initials;
        refreshUI = false;
        store.emitChange();
        break;

      case 'storeInitialsMinLength':
        initialsMinLength = {
          minLength: action.minLength,
          fontId: action.fontId
        };
        store.emitChange();
        break;

      default:
    }
  });

  return store;
};
